import { DATE_FORMAT_SHORT } from '@constants';
import { Prototype } from '@core';
import { memo } from 'react';
import { KColors, KLabel } from 'uikit';

const Today = () => {
  return (
    <KLabel.Text typo="TextMdBold" color={KColors.danger.normal}>
      Today {Prototype.date.now().format(DATE_FORMAT_SHORT).toString()}
    </KLabel.Text>
  );
};

export default memo(Today);
